import React from 'react';
import PropTypes from 'prop-types';

const ListingStreetAddress = props => {
	const { Address, SuiteNumber2, Country } = props.listing;

	const generateAddress = (address, suiteNumber2, country) => {
		let generatedAddress;

		if (suiteNumber2) {
			if (country === 'USA') {
				generatedAddress = `${address} #${suiteNumber2}`;
			} else {
				generatedAddress = `${suiteNumber2} - ${address}`;
			}
		} else {
			generatedAddress = address;
		}
		return generatedAddress;
	};

	return <React.Fragment>{generateAddress(Address, SuiteNumber2, Country)}</React.Fragment>;
};

ListingStreetAddress.propTypes = {
	listing: PropTypes.object.isRequired
};

export default ListingStreetAddress;
